import { css, paginationItemClasses, touchRippleClasses } from '@mui/material';

import type { ThemeOptions } from '@mui/material';

export const paginationItemThemes: ThemeOptions['components'] = {
  MuiPaginationItem: {
    styleOverrides: {
      root: ({ theme }) => css`
        min-width: 28px;
        height: 28px;
        padding: 8px 6px;
        margin: 2px;

        & .${touchRippleClasses.root} {
          display: none;
        }

        &.${paginationItemClasses.focusVisible} {
          background-color: inherit;
          ${theme.mixins.focusRing('outside', { inverse: false })}
        }
      `,
      page: () => css`
        color: #676f7d;
        font-size: 13px;
        font-weight: 500;
        line-height: 19.5px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
      `,
      rounded: () => css`
        border-radius: 1px;
      `,
      text: ({ theme }) => css`
        &:hover {
          background-color: #ebeef2;
          color: #131619;
        }

        &:active {
          background-color: #e3e7ed;
          color: #131619;
        }

        &.${paginationItemClasses.selected} {
          background-color: #ebeef2;
          color: #131619;

          &:hover {
            background-color: #ebeef2;
            color: #131619;
          }

          &.${paginationItemClasses.focusVisible} {
            background-color: #ebeef2;
            ${theme.mixins.focusRing('outside', { inverse: false })}
          }
        }
      `,
      disabled: () => css`
        color: #c1c7d0;
      `,
      icon: () => css`
        width: 16px;
        height: 16px;
        font-size: 16px;
        color: #131619;
      `,
      firstLast: () => css`
        min-width: 32px;
        height: 32px;
        padding: 8px 6px;
        margin: 0;
      `,
      previousNext: () => css`
        min-width: 32px;
        height: 32px;
        padding: 8px 6px;
        margin: 0;
      `,
      ellipsis: () => css`
        display: flex;
        align-items: center;
        justify-content: center;
      `,
    },
  },
};
